export default "__VITE_ASSET__B5H2hS6X__"